
import state from './moduleOutcomeManagementState'
import mutations from './moduleOutcomeManagementMutations'
import actions from './moduleOutcomeManagementActions'
import getters from './moduleOutcomeManagementGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

